var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#99A1AF",
    d: "M4.5 0C2.012 0 0 2.035 0 4.55 0 7.963 4.5 13 4.5 13S9 7.963 9 4.55C9 2.035 6.988 0 4.5 0m0 6.175c-.426 0-.835-.171-1.136-.476a1.634 1.634 0 0 1 0-2.298 1.6 1.6 0 0 1 2.272 0 1.634 1.634 0 0 1 0 2.298c-.301.305-.71.476-1.136.476"
  })));
};
export default SvgPin;